import { render, staticRenderFns } from "./addPrize.vue?vue&type=template&id=7a3a5df3&scoped=true&"
import script from "./addPrize.vue?vue&type=script&lang=js&"
export * from "./addPrize.vue?vue&type=script&lang=js&"
import style0 from "./addPrize.vue?vue&type=style&index=0&id=7a3a5df3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a5df3",
  null
  
)

export default component.exports